jQuery_T4NT(document).ready(function($) {

     /**
     *  Variant selection changed
     *  data-variant-toggle="{{ variant.id }}"
     */
	   $( document ).on( "variant:changed", function( evt ) {
	     // console.log( evt.currentVariant );
	     // $('[data-variant-toggle]').hide(0);
	     // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
	   });
});



// SIZE GUIDE CHANGE UNIT
const shirtButtons = document.querySelectorAll('.shirt-tab-btn');
const cmContent = document.getElementById('shirt-cm');
const inchContent = document.getElementById('shirt-inch');

// Hàm để chuyển đổi giữa các đơn vị
function switchUnits(event) {
    // Xóa lớp 'active' khỏi tất cả các nút
    shirtButtons.forEach(button => button.classList.remove('active'));
    
    // Đặt nút hiện tại là 'active'
    event.target.classList.add('active');

    // Hiển thị nội dung tương ứng
    if (event.target.textContent === 'Centimeters') {
        cmContent.style.display = 'block';
        inchContent.style.display = 'none';
    } else {
        cmContent.style.display = 'none';
        inchContent.style.display = 'block';
    }
}

// Gán sự kiện click cho tất cả các nút
shirtButtons.forEach(button => {
    button.addEventListener('click', switchUnits);
});
// SIZE GUIDE CHANGE UNIT
